/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 01.09.17.
 */
// In order to use directly bootstrap JavaScript components the following is required:
// jquery and bootstrap javascript components import:
const jQuery = require("jquery");   // Required by bootstrap
window.$ = window.jQuery = jQuery;

require("bootstrap");   // Required by tempusdominus-bootstrap-3

const moment = require("moment");  // Required by tempusdominus-bootstrap-3
window.moment = moment;
